// theme_colors.js

let primaryHslBase = "0";
// if (!!main.theme && main.theme === "purple") {
//   primaryHslBase = primaryHslPurple;
// } else if (!!main.theme && main.theme === "teal") {
//   primaryHslBase = primaryHslTeal;
// } else if (!!main.theme && main.theme === "gray") {
//   primaryHslBase = primaryHslGray;
// }

const primaryHslLight = {
  baseDark:             `hsl(${primaryHslBase}, 0%, 20%)`,       // 30%  // #0f618a
  base:                 `hsl(${primaryHslBase}, 0%, 30%)`,       // 30%  // #0f618a
  _base:                `hsla(${primaryHslBase}, 0%, 30%, .5)`,  // 30%  // #0f618a
  baseHover:            `hsl(${primaryHslBase}, 0%, 45%)`,       // 45%  // #1692d0
  baseMedium:           `hsl(${primaryHslBase}, 0%, 61%)`,       // 61%  // #5fb1da
  baseLight:            `hsl(${primaryHslBase}, 0%, 75%)`,       // 75%  // #8cd0f3
  baseLightHover:       `hsl(${primaryHslBase}, 0%, 82%)`,       // 75%  // #b0e0f3
  baseFooter:           `hsl(${primaryHslBase}, 0%, 82%)`,       // 82%  // #b0e0f3
  baseFooter2:          `hsl(${primaryHslBase}, 0%, 74%)`,       // 74%  // #b0e0f3
  baseFooter3:          `hsl(${primaryHslBase}, 0%, 70%)`,       // 70%  // #b0e0f3
  baseBackground:       `hsl(${primaryHslBase}, 0%, 97%)`,       // 97%  // #f1f9fe
  baseBackgroundHover:  `hsl(${primaryHslBase}, 0%, 95%)`,       // 95%  // #e6f6ff
  // Special use colors
  baseDivider:          `hsl(${primaryHslBase}, 42%, 92%)`,       // 92%  // #f1f9fe
  baseMedium2:          `hsl(${primaryHslBase}, 40%, 59%)`,       // #6da5c1,
  baseMedium3:          `hsl(${primaryHslBase}, 40%, 65%)`,       // #82b1c9,
};

const primaryHslDark = {
  baseDark:             `hsl(${primaryHslBase}, 0%, 30%)`,
  base:                 `hsl(${primaryHslBase}, 0%, 45%)`,
  _base:                `hsla(${primaryHslBase}, 0%, 45%, .5)`,
  baseHover:            `hsl(${primaryHslBase}, 0%, 60%)`,
  baseMedium:           `hsl(${primaryHslBase}, 0%, 61%)`,
  baseLight:            `hsl(${primaryHslBase}, 0%, 75%)`,
  baseLightHover:       `hsl(${primaryHslBase}, 0%, 82%)`,
  baseFooter:           `hsl(${primaryHslBase}, 0%, 82%)`,
  baseFooter2:          `hsl(${primaryHslBase}, 0%, 74%)`,
  baseFooter3:          `hsl(${primaryHslBase}, 0%, 70%)`,
  baseBackground:       `hsl(${primaryHslBase}, 0%, 13%)`,
  baseBackgroundHover:  `hsl(${primaryHslBase}, 0%, 10%)`,
  // Special use colors
  baseDivider:          `hsl(${primaryHslBase}, 42%, 92%)`,
  baseMedium2:          `hsl(${primaryHslBase}, 40%, 59%)`,
  baseMedium3:          `hsl(${primaryHslBase}, 40%, 65%)`,
};

const colors = {
  // Primary
  ...primaryHslLight,

  // Auxiliary
  // Purple
  auxiliary: "hsl(252, 54%, 44%)",  // "hsl(258, 100%, 50%)"
  auxiliaryHover: "hsl(252, 54%, 54%)",  // "hsl(252, 100%, 65%)"
  auxiliaryBackground: "hsl(250, 100%, 96%)",
  auxiliaryHighlightThin: "hsl(250, 100%, 93%)",
  _auxiliaryHighlightThin: "hsla(250, 100%, 93%,0.5)",
  auxiliaryHighlight: "hsl(250, 100%, 89%)",
  // Teal
  auxiliary: "hsl(195, 54%, 44%)",
  auxiliaryHover: "hsl(195, 54%, 54%)",
  auxiliaryBackground: "hsl(193, 100%, 96%)",
  auxiliaryHighlightThin: "hsl(193, 100%, 93%)",
  _auxiliaryHighlightThin: "hsla(193, 100%, 93%,0.5)",
  auxiliaryHighlight: "hsl(193, 100%, 89%)",
  // Ancillary
  warn: "#ffa800",
  warnMedium: "#e79901",
  warnDark: "#ce8800",
  warnHover: "#ffc34d",
  warnBackground: "#fffaf0",   // "#fff9f2",
  warnHighlightThin: "hsl(40, 100%, 93%)",  // "#ffedc9",
  warnHighlight: "hsl(40, 100%, 89%)",  // "#ffedc9",
  // Cautionary
  caution: "#dc1400",  // "#dc2800",  // "#ff5000",
  cautionDark: "#bc1400",  // "#dc2800",  // "#ff5000",
  cautionMedium: "#ff3c28",
  cautionLight: "#ff8073",
  cautionHover: "#ff2800",  // "#ff5000",  // "#ff9666",
  cautionBackground: "#fff7f5",
  cautionHighlightThin: "hsl(0, 100%, 96%)",  // "#ffd4d4",
  cautionHighlight: "hsl(0, 100%, 92%)",  // "#ffd4d4",
  _cautionHighlight: "rgba(255, 214, 214, 0.7)",  // "#ffd4d4",
  // Emphisize
  // emph: "rgb(255,235,59)",
  emph: "rgb(255,230,100)",
  _emph: "rgba(255,235,59,0.7)",
  emphDark: "rgb(255,224,96)",  // #ffe060
  emphDarkHover: "rgb(255,220,0)",  // "rgb(230,200,0)",
  emphMedium: "rgb(255,240,160)",
  emphLight: "rgb(255,250,200)",
  emphHover: "rgb(255,242,112)",
  _emphHover: "rgba(255,242,112,0.7)",
  emphBackground: "rgb(255,254,245)",  //  "#fffef5",
  emphHighlightThin: "rgb(255,249,199)",
  _emphHighlightThin: "rgba(255,249,199,0.7)",
  emphHighlight: "rgb(255,252,220)",
  _emphHighlight: "rgba(255,252,220,0.7)",
  // Success
  success: "#6baa55",
  successDark: "#227700",  // "#248a00",
  successMedium: "#88cc66",
  successLight: "#aaff88",
  successHover: "#99cc88",
  successBackground: "#f6faf5",
  successHighlightThin: "hsl(104, 52%, 92%)",
  successHighlight: "hsl(104, 52%, 87%)",// "#d6efcd",
  _successHighlight: "rgba(214, 239, 205, 0.7)",// "#d6efcd",
  newRowBg: "#e5ffe8",
  selectedBackground: "#e0e6dc",
  selectedHighBackground: "#e4f5e8",
  // Monochromatic
  monoBlack: "#1a1a1a",
  monoDark: "#444444",
  monoMedium: "#767676",
  _monoMedium: "rgb(118,118,118,0.7)",
  mono: "#999999",
  monoLight: "#bfbfbf",
  monoLight2: "#cfcfcf",
  monoDisabled: "#dadada",
  monoInputDisabled: "#eaebec",
  monoBackground: "#f2f2f2",
  // Placeholder
  placeholder: "#d0d4dc",  //"#d0d4dc" form AutoComplete
  listRowDiv: "#cad4d8",

  // Custom
  loveIt: "rgb(255,71,104)",

  black: "#000000",
  white: "#ffffff",

  ganttBorder:      "#e0e0e0",
  ganttBorderLight: "#f0f0f0",
  ganttAltRowBg:    "#f5f5f5",

  light: {
    ...primaryHslLight,
    // menuBackgroundColor: "#e0ffb2",
    menuBackgroundColor: "#eeffda",
    menuBorderColor: "#000000",
    menuTextColor: "#303330",

    containerBackgroundColor: "#ffffff",  // ⬅ Don't forget to make this match in '/packages/web/public/index.html', and in '/packages/mobile/App.js'.
    containerBackgroundColor2: "#efefef",
    containerBackgroundColor3: "#dfdfdf",
    containerBorderColor: "#444944",
    textColor: "#222222",
    textColor2: "#292929",
    textColor3: "#333333",
    inputTextColor: "#eeeeee",
    inputBackgroundColor: "#222222",
    placeholderTextColor: "#d0d4dc",
  },
  dark: {
    ...primaryHslDark,
    menuBackgroundColor: "#303330",
    menuBorderColor: "#ffffff99",
    menuTextColor: "#e0ffb2",  // menuTextColor: "#eeffda",

    containerBackgroundColor: "#222222",  // ⬅ Don't forget to make this match in '/packages/web/public/index.html', and in '/packages/mobile/App.js'.
    containerBackgroundColor2: "#323232",
    containerBackgroundColor3: "#424242",
    containerBorderColor: "#444944",
    textColor: "#eeeeee",
    textColor2: "#dedede",
    textColor3: "#cecece",
    inputTextColor: "#222222",
    inputBackgroundColor: "#eeeeee",
    placeholderTextColor: "#525252",
  },
};

export default colors;